/**
 * Formatos de fecha disponibles para campos de fecha en documentos.
 */
export const DATE_FORMATS = [
    { value: 'dd/MM/yyyy', label: 'dd/MM/yyyy  —  México / España' },
    { value: 'MM/dd/yyyy', label: 'MM/dd/yyyy  —  Estados Unidos' },
    { value: 'yyyy/MM/dd', label: 'yyyy/MM/dd  —  Internacional (ISO)' },
    { value: 'dd-MM-yyyy', label: 'dd-MM-yyyy  —  Europa (guiones)' },
    { value: 'MM-dd-yyyy', label: 'MM-dd-yyyy  —  EUA (guiones)' },
    { value: 'dd.MM.yyyy', label: 'dd.MM.yyyy  —  Alemania / Rusia' },
];

export const DEFAULT_DATE_FORMAT = 'dd/MM/yyyy';

/**
 * Convierte una fecha ISO (yyyy-MM-dd) al formato especificado.
 * @param {string} isoString - Fecha en formato yyyy-MM-dd
 * @param {string} format - Formato destino, ej. 'dd/MM/yyyy'
 * @returns {string}
 */
export const formatISODate = (isoString, format = DEFAULT_DATE_FORMAT) => {
    if (!isoString) return isoString;
    const parts = isoString.split('-');
    if (parts.length !== 3) return isoString;
    const [year, month, day] = parts;
    return format
        .replace('yyyy', year)
        .replace('MM', month)
        .replace('dd', day);
};
